import { render, staticRenderFns } from "./SectionSubmissionReviews.vue?vue&type=template&id=528c6cfc&scoped=true"
import script from "./SectionSubmissionReviews.vue?vue&type=script&lang=js"
export * from "./SectionSubmissionReviews.vue?vue&type=script&lang=js"
import style0 from "./SectionSubmissionReviews.vue?vue&type=style&index=0&id=528c6cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c6cfc",
  null
  
)

export default component.exports